import { StatusCirurgia } from "../ui/StatusBadge.tsx";

/**
 * O que `GET /cirurgia` devolve em cada item de `data.content`.
 *
 * Espelha o record `DadosListarCirurgias` do backend. Vale notar que esse DTO é
 * um SUPERSET do `DadosCirurgiaDetalhada` de `GET /cirurgia/{id}`: tem os mesmos
 * campos mais `dataCriacao` e `dataAlteracao`. Ou seja, para abrir o detalhe de
 * uma cirurgia que já está numa lista carregada não é preciso buscar de novo.
 *
 * É `interface` e não `class` como os outros arquivos desta pasta de propósito:
 * aqui não se constrói nada, só se descreve o formato que chega da API.
 *
 * Os ids são UUID em texto. A tela de Agenda declarava `id: number`, o que nunca
 * foi verdade.
 */
export interface Cirurgia {
  id: string;
  data: string;

  hospital: string;
  hospitalId: string;

  medico: string;
  medicoId: string;

  paciente: string;
  pacienteId: string;

  tipoCirurgia: string;
  tipoCirurgiaId: string;
  observacaoTipoCirurgia: string | null;

  instrumentador1: string | null;
  instrumentador1Id: string | null;
  instrumentador2: string | null;
  instrumentador2Id: string | null;
  instrumentador3: string | null;
  instrumentador3Id: string | null;

  convenio: string | null;
  convenioId: string | null;

  observacao: string | null;
  status: StatusCirurgia;
  /** Preenchido só quando `status === "CANCELADA"`. */
  motivo: string | null;

  dataCriacao: string | null;
  dataAlteracao: string | null;
}

/** A ordem em que os status aparecem na legenda e nos filtros. */
export const STATUS_CIRURGIA: { status: StatusCirurgia; label: string }[] = [
  { status: "AGENDADA", label: "Agendada" },
  { status: "SEPARADO", label: "Separado" },
  { status: "REALIZADA", label: "Realizada" },
  { status: "CANCELADA", label: "Cancelada" },
  { status: "ABERTO", label: "Aberto" },
];
